module.exports = __webpack_public_path__ + "static/media/HCMM172.3cf839e6.jpg";